import{ useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./RegistrationHub.css";

const RegistrationHub = () => {
  // ✅ Real Data from your message
  const personalHubData = [
    {
      title: "Safe Document Storage",
      description:
        "Upload your important documents, and we’ll keep them secure, accessible anytime.",
      icon: "bi-shield-lock-fill",
    },
    {
      title: "Expiry Alerts",
      description:
        "Never miss a deadline, get timely notifications for document expiries.",
      icon: "bi-bell-fill",
    },
    {
      title: "Renewal Reminders",
      description:
        "Stay ahead with reminders for renewals so you can act before it’s too late.",
      icon: "bi-clock-fill",
    },
    {
      title: "Track Orders & Services",
      description:
        "Keep an eye on all your ongoing requests, deliveries, and service updates in real-time.",
      icon: "bi-graph-up-arrow",
    },
    {
      title: "Manage All Documents",
      description:
        "Organize, download, and access your personal documents from one central hub.",
      icon: "bi-folder-fill",
    },
    {
      title: "Personalized Dashboard",
      description:
        "Get a clear view of your services, notifications, and activity history tailored to you.",
      icon: "bi-speedometer",
    },
    {
      title: "Seamless Access Anywhere",
      description:
        "Your account is available on desktop and mobile for complete convenience.",
      icon: "bi-laptop-fill",
    },
    {
      title: "Faster Service Requests",
      description:
        "Submit and manage new requests instantly without repeated steps.",
      icon: "bi-lightning-charge-fill",
    },
  ];
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992); // ✅ below 992px = centered
    };
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {" "}
      <div className="container-fluid regMainAssist py-2 pb-5 py-md-5">
        <div className="container">
          {/* -------- Section 1: Slider -------- */}
          <div className=" mb-5">
            <div
              className="font-12 ff-semibold text-center glair-wrap bg-3 d-md-flex mx-auto mx-md-0 d-block align-items-center gap-1 px-3 my-3 rounded-pill"
              style={{ width: "fit-content" }}
            >
              <span className="ms-1 glair">Track, Manage, and Relax</span>
            </div>

            <h2 className="text-center text-md-start font-25 font-sm-18 text-black ff-bold mb-3">
              Personal Hub at Goodhand
            </h2>
          </div>

          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            centeredSlides={isMobile}
            loop={true}
            spaceBetween={15}
            breakpoints={{
              320: { slidesPerView: 1.8 },
              576: { slidesPerView: 1.8 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="regMainSwiper pb-1 pb-md-5"
          >
            {personalHubData.map((card, index) => (
              <SwiperSlide key={index} className="py-3 bg-transparent">
                <div className="regMainCard text-center p-4 bg-white shadow-sm rounded-4 h-100 d-flex align-items-center justify-content-between flex-column">
                  <div className="mb-3 text-main-grad d-flex align-items-center justify-content-center">
                    <i className={`bi ${card.icon} font-30 icon-gradient`}></i>
                  </div>

                  <h5 className="font-16 font-sm-14 ff-bold text-black mb-2">
                    {card.title}
                  </h5>
                  <p className="font-12 font-sm-10 text-muted reg-desc">
                    {card.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="align-items-start row flex-sm-col-reverse flex-md-row align-items-start ">
            <div className="col-md-6 text-center mt-4 mt-md-0  d-none d-md-block">
              <img
                src="https://goodhand.b-cdn.net/Assets/Registration/337%20(3)%201.png"
                alt="Laptop"
                className="img-fluid regMainImage"
              />
            </div>
            <div className="col-md-6 ">
              <div
                className="font-12 ff-semibold text-center glair-wrap bg-3 d-flex align-items-center gap-1 px-3 my-3 rounded-pill"
                style={{ width: "fit-content" }}
              >
                <img
                  src="https://goodhand.b-cdn.net/Assets/Footer_pages/Amer/abt-tile-ico.svg"
                  alt="about"
                />
                <span className="ms-1 glair">
                  Connecting People to Governance
                </span>
              </div>

              <h2 className="text-left font-25 text-black ff-bold mb-3">
                Our Vision
              </h2>

              <p className="font-14 text-muted text-justify">
                Goodhand is your trusted partner and an authorized federal
                authority platform for a wide range of government services in
                the UAE. We simplify access to essential services such as Amer,
                Emirates ID, DHA, Tasheel, Tawjeeh, Al Adheed, Legal
                Translation, Notary Services, DET, Business Setup, Trademark,
                RTA, Montaji, and many more. Our mission is to provide a secure,
                convenient, and efficient platform where you can manage all your
                documents, applications, and renewals in one place, with the
                assurance of dealing with a recognized and trusted partner.
              </p>

              <p className="font-14 text-muted mb-0 text-justify">
                Whether it’s tracking your applications, storing documents
                safely, receiving timely notifications, or getting expert
                guidance, Goodhand ensures a smooth experience every step of the
                way. Being an authorized partner for federal and government
                services, we connect you directly with official processes,
                making your journey faster, reliable, and hassle-free. With a
                wide range of services now and the flexibility to add more in
                the future, we aim to be your go-to hub for personal, legal, and
                business needs, helping you stay organized, save time, and
                manage everything with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 text-center mt-4 mt-md-0  d-none d-md-none justify-content-center">
        <img
          src="https://goodhand.b-cdn.net/Assets/Registration/337%20(3)%201.png"
          alt="Laptop"
          className="img-fluid regMainImage"
        />
      </div>
    </>
  );
};

export default RegistrationHub;
